import React, { FC } from "react";
import "./layout-app.less";
import "./main.css";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "app.store";
import AsideComponent from "./aside";
type LayoutAppProps = any;

const LayoutApp: FC<LayoutAppProps> = (props) => {
  const isLogin = useSelector(
    (state: RootState) => state.account.isAuthentication,
    shallowEqual
  );
  const currentUser = useSelector(
    (state: RootState) => state.account.currentUser,
    shallowEqual
  );
  return isLogin ? (
   <div id="account-page">
      <div className="layout-page container">
      <AsideComponent currentUser={currentUser} />
      <div id="content">
        {props.children}
      </div>
    </div>
   </div>
  ) : null;
};

export default LayoutApp;
